module.exports = __webpack_public_path__ + "img/reviews-image6.244ef08c.jpg";